import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DataOwnerManagementPage } from './DataOwnerManagement/DataOwnerManagementPage';
import { DataOwnerPage } from './DataOwners/DataOwnerPage';

export function DataOwnerRoutes(): React.ReactElement {
  return (
    <Switch>
      <Route path="/dataOwners/" exact>
        <DataOwnerPage addNew={false} />
      </Route>
      <Route path="/dataOwners/addNew" exact>
        <DataOwnerPage addNew={true} />
      </Route>
      <Route path="/dataOwners/:paramDataOwnerId/addNew">
        <DataOwnerManagementPage addNew={true} />
      </Route>
      <Route path="/dataOwners/:paramDataOwnerId/:paramRequestId">
        <DataOwnerManagementPage addNew={false} />
      </Route>
      <Route path="/dataOwners/:paramDataOwnerId">
        <DataOwnerManagementPage addNew={false} />
      </Route>
    </Switch>
  );
}
